// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2mCzB","title":"Images45_title__3bGAX","images":"Images45_images__1UOGX"};